// extracted by mini-css-extract-plugin
export default {"card__title":"Card_card__title__YTatu"};